var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form__sidepanel"},[(_vm.currentPageIndex > 0)?_c('OfferInformation',{staticClass:"hide--mobile",staticStyle:{"margin-bottom":"2.1rem"}}):_vm._e(),_c('ProductionInformation')],1)}
var staticRenderFns = []

export { render, staticRenderFns }